import React from 'react'; 
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import util from "../../../lib/util";
import * as consts from '../../../constants';
import ApplicantsInfo from './ApplicantsInfo';

class BuildingDetailsInfo extends React.Component {
    render() {
        const p = this.props;
        const lookup = window.osa.lookup.submitRequest;
        if (p.pageName == consts.SERVICE_REMOVAL_NAME) {
            const vacantMsg = util.getNamebyId(lookup.vacantTypes.items, +p.vacantType);
            const reasonMsg = util.getNamebyId(lookup.reasonTypes.items, +p.reasonType);
            const demolishReasonMsg = util.getNamebyId(lookup.demolishReasonTypes.items, +p.demolishReasonType);
            return (
                <div className="row">
                    <div className="col-sm-12">
                        <b>Building details:</b>
                        <br />
                        <span>{vacantMsg}</span>
                        <br />
                        <span>{reasonMsg}</span>
                        <br />
                        <span>{demolishReasonMsg}</span>
                        <br />
                        <br />
                    </div>
                </div>);
        }
        else if (p.pageName == consts.NEW_GAS_LINE_NAME) {
            let deliveryPressure = null;
            if (p.gasDeliveryPressure) {
                deliveryPressure = util.getNamebyId(window.osa.lookup.projectSpecifics.gasDeliveryPressure.items, parseInt(p.gasDeliveryPressure));
            }
            else {
                deliveryPressure = util.getNamebyId(window.osa.lookup.projectSpecifics.gasDeliveryPressure.items, 1);
            }
            return (
                <div>
                    <div className="row">
                        <div className="col-sm-12">
                            <b>Building type:</b>
                            <br />
                            <span>{util.getNamebyId(window.osa.lookup.serviceAddress.buildingType.items, p.buildingType)}</span>
                            <br />
                            <br />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <b>Meter location:</b>
                            <br />
                            <span>{util.getNamebyId(window.osa.lookup.projectSpecifics.meterLocation.items, p.meterLocation)}</span>
                            <br />
                            <br />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <b>Delivery pressure:</b>
                            <br />
                            <span>{deliveryPressure}</span>
                            <br />
                            <br />
                        </div>
                    </div>
                    <ApplicantsInfo />
                </div>
            );
        }

    }
}
const mapStateToProps = (state) => {
    return {
        vacantType: state.form.vacantType,
        reasonType: state.form.reasonType,
        demolishReasonType: state.form.demolishReasonType,
        buildingType: state.form.buildingType,
        meterLocation: state.form.meterLocation,
        gasDeliveryPressure: state.form.gasDeliveryPressure,
        differentDeliveryPressure: state.form.differentDeliveryPressure,
        pageName: state.gas.pageName,
    };
};
BuildingDetailsInfo.propTypes = {
    vacantType: PropTypes.string,
    reasonType: PropTypes.number,
    demolishReasonType: PropTypes.number,
};

export default connect(mapStateToProps)(BuildingDetailsInfo);